import {Fancybox, Carousel} from '@fancyapps/ui';
import {Autoplay} from '@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js';

Alpine.data('PhytorinProductGallery', (element) => ({
    init() {
        this.initFancyBox();
        this.initCarousel();
    },

    initFancyBox() {
        Fancybox.bind('[data-fancybox]', {});
    },

    initCarousel() {
        new Carousel(document.getElementById('product-gallery-mobile'), {
            infinite: true,
            Autoplay: {
                timeout: 3000
            }
        }, {Autoplay});
    }
}));